import React from "react";
import FooterMediaInformations from "../components/footerComponents/footerMediaInformations";
import FooterContactInformations from "../components/footerComponents/footerContactInformations";
import FooterResponsiveDropdown from "../components/footerComponents/footerResponsiveDropdowns";
import "./footer.scss";
const Footer = () => {
    return (
      <div className="footer">
        <div className="footer-top">
          <FooterMediaInformations />
          <div className="text-section">
          <div className="item">
            <span className="title">Our Mission</span>
            <span className="description">At Cube Global, our mission is to empower businesses with innovative, custom-built software solutions that drive growth and success in the digital era. We are committed to delivering exceptional value through cutting-edge technology, strategic consulting, and unparalleled expertise. By continuously pushing the boundaries of what’s possible, we help our clients stay competitive, streamline their operations, and achieve their long-term goals.</span>
          </div>
          </div>
  
          {/* <FooterResponsiveDropdown
            title={"Useful links"}
            options={["Services", "Careers", "FAQs"]}
          
          />
          <FooterResponsiveDropdown
            title={"Community"}
            options={["Developer Forum", "Webinars & Workshops", "Newsletter"]}
          
          />
          <FooterResponsiveDropdown
            title={"About Us"}
            options={["About Us", "Partnership", "Contact Us"]}
          
          /> */}
        </div>
  
        <FooterContactInformations className="footer-contact" />
      </div>
    );
  };

export default Footer;
